/**
 * Language Switcher Module
 * Handles language switching functionality for desktop and mobile views
 */

/**
 * Toggle language switcher dropdown
 * @param {string} type - 'desktop' or 'mobile' to specify which switcher to toggle
 */
export function toggleLanguageSwitcher(type = 'desktop') {
  const menuId = type === 'mobile' ? 'mobile-language-menu' : 'language-menu';
  const switcherId = type === 'mobile' ? 'mobile-language-switcher' : 'language-switcher';
  
  const menu = document.getElementById(menuId);
  const switcher = document.getElementById(switcherId);
  
  if (!menu || !switcher) {
    return;
  }
  
  const isHidden = menu.classList.contains('hidden');
  
  if (isHidden) {
    menu.classList.remove('hidden');
    switcher.setAttribute('aria-expanded', 'true');
  } else {
    menu.classList.add('hidden');
    switcher.setAttribute('aria-expanded', 'false');
  }
}

// Close language switcher when clicking outside. Elements are looked up on
// every click, so one document-level listener also covers swapped content.
function handleOutsideClick(event) {
  const desktopSwitcher = document.getElementById('language-switcher');
  const desktopMenu = document.getElementById('language-menu');
  const mobileSwitcher = document.getElementById('mobile-language-switcher');
  const mobileMenu = document.getElementById('mobile-language-menu');
  
  // Check if click is outside desktop switcher
  if (desktopSwitcher && desktopMenu && 
      !desktopSwitcher.contains(event.target) && 
      !desktopMenu.contains(event.target)) {
    desktopMenu.classList.add('hidden');
    desktopSwitcher.setAttribute('aria-expanded', 'false');
  }
  
  // Check if click is outside mobile switcher
  if (mobileSwitcher && mobileMenu && 
      !mobileSwitcher.contains(event.target) && 
      !mobileMenu.contains(event.target)) {
    mobileMenu.classList.add('hidden');
    mobileSwitcher.setAttribute('aria-expanded', 'false');
  }
}

/**
 * Initialize language switcher event listeners
 */
export function init() {
  // Same function reference every time, so this never stacks listeners
  // (re-running init on every HTMX swap used to add a new one each time).
  document.addEventListener('click', handleOutsideClick);
}

// Make function globally available
window.toggleLanguageSwitcher = toggleLanguageSwitcher;